import { render, staticRenderFns } from "./JinLuoCurrentTime.vue?vue&type=template&id=019a0bf1&scoped=true"
import script from "./JinLuoCurrentTime.vue?vue&type=script&lang=js"
export * from "./JinLuoCurrentTime.vue?vue&type=script&lang=js"
import style0 from "./JinLuoCurrentTime.vue?vue&type=style&index=0&id=019a0bf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019a0bf1",
  null
  
)

export default component.exports